module["exports"] = [
  "#{building_number} #{street_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/street_address.js
// module id = 843
// module chunks = 0